import React, { useState, useEffect } from "react";
import callingAPI from "../service";
import { useSelector } from 'react-redux';


const ExchangeAllocationPopUp = ({ data, onClose }) => {
  const dashboardDetails = useSelector((state) => state.Dashboard);

  const [exchangeAllocationDetails, setExchangeAllocationDetails] = useState([]);
  const [loaderFlag, setLoaderFlag] = useState(false);
  const [marketValueSum, setMarketValueSum] = useState(0); // New state for sum

  const refreshToken = dashboardDetails.refreshToken;

  useEffect(() => {
    let isMounted = true;

    const handleExchangeAllocationDetails = async () => {
      try {
        const userId = dashboardDetails.userId
        const postData = {
          "userId": userId,
          //"refreshToken": refreshToken
        };

        const response = await callingAPI(postData, "reports/getExchangeAllocationDetails", 'post');

        if (isMounted) {
          if (response.data?.statusCode === 200) {
            console.log("🚀 ~ handleExchangeAllocationDetails ~ response.data.data:", response.data.data)
            // Filter data based on selectedData.label matching exchangedesc
            const filteredData = response.data.data.filter(item =>
              item.exchangedesc === data.label
            );

            console.log("🚀 ~ Filtered Data:", filteredData);
            const totalMarketValue = filteredData.reduce((sum, item) => sum + (Number(item.marketValue) || 0), 0);

            setExchangeAllocationDetails(filteredData || []);
            setMarketValueSum(totalMarketValue);
            setLoaderFlag(true);
            // setExchangeAllocationDetails(response.data.data || []);
            // setLoaderFlag(true);
          } else {
            setExchangeAllocationDetails([]);
            setMarketValueSum(0);
            console.error('Failed to fetch profile details:', response.data?.message);
          }

        }
      } catch (error) {
        if (isMounted) {
          console.error('Error during profile fetch:', error);
          setExchangeAllocationDetails([]);
          setMarketValueSum(0);
          setLoaderFlag(true);
        }
      }
    };

    handleExchangeAllocationDetails();

    return () => {
      isMounted = false;
    };
  }, [refreshToken]);

  return (
    <div className="overlay-notification graph-popup">
      <div className="modal fade show border-0" style={{ display: 'block', cursor: "default" }} tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <div className="popup-subhead">Exchange Allocation Details - {data.label}</div>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>
            <div className="modal-body text-center">
              {loaderFlag ? (
                <div className="popup-table col-12 m-auto">
                  <div className="table-responsive">
                    <table className="table table-bordered mb-0">
                      <thead>
                        <tr>
                          <th>Stock Name</th>
                          <th>Quantity</th>
                          <th>Market Price</th>
                          <th>Market Value</th>

                        </tr>
                      </thead>
                      <tbody>
                        {exchangeAllocationDetails.length > 0 ? (
                          exchangeAllocationDetails.map((data, index) => (
                            <tr key={index}>
                              <td>{data.stockName}</td>
                              <td>
                                <span className={Number(data.quantity) < 0 ? 'text-red-500' : ''}>
                                  {Number(data.quantity) < 0
                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(data.quantity)) || 0)})`
                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(data.quantity) || 0)}
                                </span>
                              </td>

                              <td>
                                <span className={Number(data.marketPrice) < 0 ? 'text-red-500' : ''}>
                                  {Number(data.marketPrice) < 0
                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(data.marketPrice)) || 0)})`
                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(data.marketPrice) || 0)}
                                </span>
                              </td>
                              <td>
                                <span className={Number(data.marketValue) < 0 ? 'text-red-500' : ''}>
                                  {Number(data.marketValue) < 0
                                    ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(data.marketValue)) || 0)})`
                                    : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(data.marketValue) || 0)}
                                </span>
                              </td>

                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center py-8">
                              No Data
                            </td>
                          </tr>
                        )}

                        {exchangeAllocationDetails.length > 0 && (
                          <tr className="font-bold bg-gray-200">
                            <td>Total</td>
                            <td></td> {/* Empty for alignment */}
                            <td></td> {/* Empty for alignment */}
                            <td>
                              <span className={marketValueSum < 0 ? 'text-red-500' : ''}>
                                {marketValueSum < 0
                                  ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(marketValueSum))})`
                                  : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(marketValueSum)}
                              </span>
                            </td>
                          </tr>
                        )}

                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="flex justify-center items-center min-h-[200px]">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExchangeAllocationPopUp;